import { ChangeDetectionStrategy, Component, ElementRef, computed, inject, input } from '@angular/core'
import type { ButtonSize } from '@awork/_shared/types/size'
import { Size } from '@awork/_shared/types/size'
import { Color } from '@awork/_shared/types/color'
import { TooltipDirective } from '../../../directives/tooltip/tooltip.directive'
import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'

@Component({
  selector: 'aw-fab-button',
  templateUrl: './fab-button.component.html',
  styleUrls: ['./fab-button.component.scss'],
  imports: [TooltipDirective, IconsDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled()',
    '(click)': 'onClick($event)'
  }
})
export class FabButtonComponent {
  readonly icon = input.required<string>()
  readonly tooltip = input<string>()
  readonly color = input<Color.Blue | Color.White | Color.Red>(Color.White)
  readonly size = input<ButtonSize>(Size.m)
  readonly tooltipOnTop = input<boolean>()
  readonly suppressClick = input(false)
  readonly disabled = input(false)

  /**
   * Handles host click events.
   * @param {MouseEvent} event Event emitted by the host listener.
   */
  onClick(event: MouseEvent) {
    if (!this.suppressClick()) {
      event.preventDefault()

      if (this.disabled()) {
        event.stopPropagation()
      }
    }
  }

  readonly iconButtonClasses = computed(() => this.getIconButtonClasses())
  elementRef: ElementRef = inject(ElementRef)

  /**
   * Initializes all classes used to style the icon button.
   * @returns {string[]} The classes used to style the icon button.
   */
  getIconButtonClasses(): string[] {
    return [`btn-icon--${this.color()}`, `btn-icon--${this.size()}`]
  }
}
